/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/NewTask/Content/Title",
  onChange
  
}) {
let requirementNewTaskTitleValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
path: 'new_task.title',
})
let requirementNewTaskTitleChangeData = fromData.useDataChange({ viewPath,
context: 'requirement',
path: 'new_task.title',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 data="requirement.new_task.title"
 value={requirementNewTaskTitleValueData}
 onChange={requirementNewTaskTitleChangeData}
 required={true}
 marginTop={0}
 marginBottom={0}
 width="100%"
 label="Title"
 placeholder="Schedule online appointment"
/>
{children}
</React.Fragment>)
}